import { gsap, ScrollTrigger } from '../global/gsap';

const initHideMenu = () => {
    ScrollTrigger.create({
        trigger: document.body,
        endTrigger: document.querySelector('footer'),
        invalidateOnRefresh: true,
        start: () => 'top top',
        onUpdate: (self) => {
            if (self.isActive) {
                if (self.direction === 1) {
                    document.body.classList.remove('scrolling-up');
                    document.body.classList.add('scrolling-down');
                } else {
                    document.body.classList.remove('scrolling-down');
                    document.body.classList.add('scrolling-up');
                }
            } else {
                document.body.classList.remove('scrolling-up', 'scrolling-down');
            }
        }
    });
};

export default initHideMenu;
